import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Events, ToastController } from "ionic-angular";
import { Observable } from "rxjs";
import { ConfigurationService } from "../configuration/configuration.service";
import { StateManagementService } from "../state-management/state-management.service";

@Injectable()
export class PatientChartStatusServiceProvider {
  chartStatusUrl: string;
  headers = new HttpHeaders().set("Content-Type", "application/json");

  constructor(
    public http: HttpClient,
    public events: Events,
    private toastCtrl: ToastController,
    private stateService: StateManagementService,
    private configurationService: ConfigurationService
  ) {
    this.chartStatusUrl =
      configurationService.getConfig().patientChartStatusUrl;
  }

  //STIN-286
  getPatientChartStatusSpecification(patientChartId, action) {
    let lookupUrl = `${this.chartStatusUrl}/patient-charts/${patientChartId}/specifications`;
    if (action) {
      lookupUrl = lookupUrl + "?action=" + action;
    }

    return new Observable((observer) => {
      this.http.get(lookupUrl, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  /**
   * Create status data
   * @param statusData
   * @param {string} patientId
   * @returns {Observable<any>}
   */
  postStatusData(patientChartId, statusData: any) {
    let url: string = `${this.chartStatusUrl}/patient-charts/${patientChartId}/statuses`;
    return new Observable((observer) => {
      this.http
        .put(url, JSON.stringify(statusData), { headers: this.headers })
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  /**
   * Update status data
   * @param statusData
   * @param {string} patientId
   * @returns {Observable<any>}
   */
  putStatusData(patientChartId, statusData: any) {
    let url: string = `${this.chartStatusUrl}/patient-charts/${patientChartId}/status`;
    return new Observable((observer) => {
      this.http
        .put(url, JSON.stringify(statusData), { headers: this.headers })
        .subscribe(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          (err) => {
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  /**
   * get patient status
   * @param {any} patientId
   * @returns {Observable<any>}
   */
  getPatientStatuses(patientChartId: any) {
    let url: string = `${this.chartStatusUrl}/patient-charts/${patientChartId}/statuses`;
    return new Observable((observer) => {
      this.http.get(url, { headers: this.headers }).subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (err) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/patient-charts/patient-chart-status-service.ts